module.exports = __webpack_public_path__ + "img/logo-moben.svg?39a17a7482dde81eff6db06886864612";